import React, { ReactNode } from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: ReactNode;
  tone?: 'light' | 'dark';
};
export function SectionHeading({
  eyebrow,
  title,
  tone = 'light'
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <div className="mx-auto max-w-3xl text-center" data-id="element-297" data-mp="3f36q7i3iln6m">
      {eyebrow && <p className={`text-[12px] font-bold uppercase tracking-[0.14em] ${isDark ? 'text-[#C9B8F5]' : 'text-brand'}`} data-id="element-298" data-mp="3k0yjaffwbfce">{eyebrow}</p>}
      <h2 className={`mt-3 text-balance font-serif text-[30px] font-extrabold leading-[1.12] sm:text-4xl lg:text-[44px] ${isDark ? 'text-white' : 'text-ink'}`} data-id="element-299" data-mp="bmpxbq7vpmt7">
        {title}
      </h2>
    </div>;
}